import {
  OnPersonCreateRequestRequest,
  OnPersonExtendedUpdateRequestRequest,
  OnPersonVerifyEmailRequestRequest,
  ParticipantsPersonEventsApi,
  ResetLastLoggedInRequestMailRequest
} from '@DigitaleDoerfer/digitale-doerfer-api';
import { useCallback, useMemo } from 'react';
import { handleError } from 'utils';
import { useGetDDServiceApiConfiguration } from './dd.service';

export const useParticipantsPersonEventsApi = () => {
  const configuration = useGetDDServiceApiConfiguration();
  const apiInstance = useMemo(
    () => new ParticipantsPersonEventsApi(configuration),
    [configuration]
  );

  const createPerson = useCallback(
    (requestParameters: OnPersonCreateRequestRequest) =>
      apiInstance.onPersonCreateRequest(requestParameters).catch(handleError),
    [apiInstance]
  );

  const updatePerson = useCallback(
    (requestParameters: OnPersonExtendedUpdateRequestRequest) =>
      apiInstance
        .onPersonExtendedUpdateRequest(requestParameters)
        .catch(handleError),
    [apiInstance]
  );

  const confirmAccount = useCallback(
    (requestParameters: ResetLastLoggedInRequestMailRequest) =>
      apiInstance
        .resetLastLoggedInRequestMail(requestParameters)
        .catch(handleError),
    [apiInstance]
  );

  const verifyMail = useCallback(
    (requestParameters: OnPersonVerifyEmailRequestRequest) =>
      apiInstance
        .onPersonVerifyEmailRequest(requestParameters)
        .catch(handleError),
    [apiInstance]
  );

  return { confirmAccount, verifyMail, createPerson, updatePerson };
};
